import type { DealStage, LabeledValue, NoteStatus } from "../types";

export interface WonFollowUpRule {
  type: string;
  text: string;
}

export interface TenantBlueprint {
  title: string;
  currency: string;
  companySectors: LabeledValue[];
  dealStages: DealStage[];
  dealPipelineStatuses: string[];
  dealCategories: LabeledValue[];
  noteStatuses: NoteStatus[];
  taskTypes: LabeledValue[];
  wonFollowUp: Record<string, WonFollowUpRule[]>;
}

export const arkaTenantBlueprint: TenantBlueprint = {
  title: "ARKA CRM",
  currency: "COP",
  companySectors: [
    { value: "beauty-salon", label: "Salón / barbería / uñas" },
    { value: "ecommerce", label: "Ecommerce / retail" },
    { value: "professional-services", label: "Servicios profesionales" },
    { value: "software-saas", label: "Software / SaaS" },
    { value: "health", label: "Salud / clínica" },
    { value: "food-hospitality", label: "Comida / hotel" },
    { value: "hardware-store", label: "Ferretería / oficios" },
    { value: "education", label: "Educación" },
    { value: "agency", label: "Agencia / marketing" },
    { value: "other", label: "Otro" },
  ],
  dealStages: [
    { value: "captured", label: "Captado" },
    { value: "qualified", label: "Calificado" },
    { value: "diagnosis_booked", label: "Diagnóstico agendado" },
    { value: "diagnosis_done", label: "Diagnóstico realizado" },
    { value: "proposal", label: "Propuesta enviada" },
    { value: "negotiation", label: "Negociación" },
    { value: "won", label: "Cerrado ganado" },
    { value: "onboarding", label: "Onboarding" },
    { value: "active", label: "Cliente activo" },
    { value: "lost", label: "Cerrado perdido" },
  ],
  dealPipelineStatuses: ["won", "lost"],
  dealCategories: [
    { value: "diagnostico", label: "Diagnóstico" },
    { value: "web", label: "Desarrollo Web Premium" },
    { value: "chasqui", label: "Chasqui / WhatsApp IA" },
    { value: "booking", label: "Agendamiento inteligente" },
    { value: "prospector", label: "Prospector / automatizaciones" },
    { value: "integraciones", label: "Integraciones y APIs" },
    { value: "identidad", label: "Identidad de marca" },
    { value: "crm", label: "ARKA CRM Cloud" },
    { value: "other", label: "Otro" },
  ],
  noteStatuses: [
    { value: "cold", label: "Frío", color: "#8B9CB3" },
    { value: "warm", label: "Tibio", color: "#7EC8E3" },
    { value: "hot", label: "Caliente", color: "#00AAFF" },
    { value: "in-contract", label: "En contrato", color: "#12B886" },
  ],
  taskTypes: [
    { value: "none", label: "Ninguno" },
    { value: "call", label: "Llamada" },
    { value: "whatsapp", label: "WhatsApp" },
    { value: "email", label: "Email" },
    { value: "meeting", label: "Reunión" },
    { value: "diagnosis", label: "Diagnóstico" },
    { value: "proposal", label: "Enviar propuesta" },
    { value: "follow-up", label: "Seguimiento" },
    { value: "onboarding", label: "Onboarding postventa" },
    { value: "upsell-chasqui", label: "Impulsar Chasqui" },
    { value: "upsell-web", label: "Impulsar web" },
    { value: "upsell-crm", label: "Impulsar CRM" },
  ],
  wonFollowUp: {
    crm: [
      {
        type: "upsell-chasqui",
        text: "Cliente con CRM: ofrecer Chasqui (WhatsApp 24/7) conectado al mismo funnel.",
      },
      {
        type: "upsell-web",
        text: "Cliente con CRM: revisar si la web ya manda leads al CRM.",
      },
    ],
    web: [
      {
        type: "upsell-chasqui",
        text: "Cliente con web ARKA: ofrecer Chasqui para no perder el WhatsApp del sitio.",
      },
      {
        type: "upsell-crm",
        text: "Cliente con web: ofrecer ARKA CRM Cloud.",
      },
    ],
    chasqui: [
      {
        type: "upsell-crm",
        text: "Cliente con Chasqui: conectar el agente al CRM.",
      },
    ],
    booking: [
      {
        type: "upsell-crm",
        text: "Cliente con agenda: el historial de citas debe vivir en el CRM.",
      },
    ],
    prospector: [
      {
        type: "upsell-crm",
        text: "Cliente con Prospector: importar el CSV al CRM, no dejarlo en Excel.",
      },
    ],
    integraciones: [
      {
        type: "follow-up",
        text: "Cliente de integraciones: verificar que la API sigue sincronizada.",
      },
    ],
    identidad: [
      {
        type: "upsell-web",
        text: "Cliente de marca: ofrecer Desarrollo Web Premium con esa identidad.",
      },
    ],
    diagnostico: [
      {
        type: "proposal",
        text: "Diagnóstico cerrado: enviar propuesta del producto que calzó.",
      },
    ],
  },
};
